<vertical-layout *ngIf="layout === 'vertical'"></vertical-layout>
<horizontal-layout  *ngIf="layout === 'horizontal'"></horizontal-layout>
